import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="bg-card border-2 border-border p-10 max-w-md w-full text-center block-shadow">
        <XCircle className="text-muted-foreground mx-auto mb-4" size={44} />
        <h1 className="font-display text-2xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mb-6">No charge made. You can subscribe whenever you're ready.</p>
        <Button data-testid="cancel-back" onClick={() => nav("/subscribe")} className="w-full h-12 bg-primary hover:bg-white hover:text-primary rounded-none font-bold overline">Back to Subscribe</Button>
      </div>
    </div>
  );
}
